"use client"

import { ConfigProvider, Modal } from "antd"
import clsx from "clsx"
import Image from "next/image"
import failedPng from "../../assets/images/rewards-program/failed.png"
import succeedPng from "../../assets/images/rewards-program/succeed.png"

const ENUM_TYPE = {
  SUCCEED: "succeed",
  FAILED: "failed",
}

const RedeemModal = (props) => {
  const {
    open,
    onCancel,
    onOk,
    title,
    description,
    type,
    confirmText,
    cancelText,
  } = props

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 0,
        },
      }}
    >
      <Modal
        open={open}
        width={800}
        footer={null}
        className={clsx(
          "lg_[&_.ant-modal-content]_px-[22px] lg_[&_.ant-modal-content]_py-[60px]",
          "[&_.ant-modal-content]_px-3 [&_.ant-modal-content]_py-8"
        )}
        centered
        onCancel={onCancel}
        zIndex={1001}
      >
        <div className="flex flex-col items-center">
          {(type === ENUM_TYPE.SUCCEED || type === ENUM_TYPE.FAILED) && (
            <Image
              alt={type}
              width={66}
              height={60}
              className=" w-[52px] lg_w-[66px]"
              src={type === ENUM_TYPE.SUCCEED ? succeedPng : failedPng}
            />
          )}

          <h2 className="font-poppins mt-5 text-center text-lg font-normal uppercase leading-[30px] text-primary lg_text-xl">
            {title}
          </h2>
          {!!description && (
            <div className="mt-2.5 text-center font-sans text-base font-semibold leading-[30px] text-[#656363] lg_text-[18px]">
              {description}
            </div>
          )}
          <div
            className={clsx(
              "mt-6 flex  w-full items-center justify-center lg_mt-[50px]",
              "flex-col gap-x-20 gap-y-4 sm_flex-row"
            )}
          >
            {!!confirmText && (
              <button
                className={clsx(
                  "flex h-[50px] w-full items-center justify-center lg_h-[60px] lg_w-[200px]",
                  "font-poppins bg-primary text-sm font-normal leading-5 text-white active_scale-[.97] lg_text-base"
                )}
                onClick={onOk}
              >
                {confirmText}
              </button>
            )}
            {!!cancelText && (
              <button
                className={clsx(
                  "h-[50px] w-full  lg_h-[60px] lg_w-[200px]",
                  "flex items-center justify-center",
                  " font-poppins bg-white text-sm font-normal leading-5 text-primary active_scale-[.97] lg_text-base",
                  "border-2 border-solid border-primary"
                )}
                onClick={onCancel}
              >
                {cancelText}
              </button>
            )}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  )
}

export default RedeemModal
